import styled from 'styled-components'
import { images } from '../../helpers/PreCache'


export const LoginPg = styled.div`
  min-height: calc(100vh - 262px);
  padding-top: 100px;
  background-color: black;
  background-image: url(${images.mainBg});
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  color: white;

  display: flex;
  justify-content: center;
  align-items: center;

  text-align: center;


  .loginBox {
    border-radius: 14px;
    background: rgba(0,0,0,0.6);
    text-align: center;
    width: 90%;
    max-width: 650px;
    padding: 3em;
    margin: 1em auto;
  }

  h2 {
    font-size: 2.2em;
    font-weight: 600;

    @media only screen and (max-width: 600px) {
      font-size: 1em;
    }
  }

  h5 {
    padding-top: 20px;
    padding-bottom: 20px;

    @media only screen and (max-width: 600px) {
      padding-bottom: 0;
    }
  }

  form {
    margin: 0 auto;
    width: 100%;
  }

  label {
    font-weight: 600;
    font-size: 0.9em;
  }

  input {
    border-radius: 10px;
    padding: 10px;
    border: none;
    outline: none;
    background-color: #1a1c21d9;
    color: white;
    width: 50%;
    text-align: center;

    @media only screen and (max-width: 600px) {
      width: 100%;
    }
  }

  input::placeholder {
    /* text-transform: uppercase; */
    font-style: italic;
    text-align: center;
  }

  button {
    text-transform: uppercase;
    font-weight: 600;
    width: 50%;

    @media only screen and (max-width: 600px) {
      width: 100%;
      margin-bottom: 20px;
    }
  }

  .bottom-text {
    @media only screen and (max-width: 600px) {
      font-size: 0.7em;
    }
  }
`
